import { ChangeDetectorRef, Directive, ElementRef } from "@angular/core";
import { UntilDestroy } from "@ngneat/until-destroy";

@UntilDestroy()
@Directive({
	selector: "[ScrollToHere]",
	standalone: false
})
export class ScrollToHere {
	constructor(
		private self: ElementRef,
		private cdr: ChangeDetectorRef
	) {}

	public scrollToBottom(): void {
		this.cdr.detectChanges();
		this.self.nativeElement.scrollIntoView({ behavior: "smooth" });
	}
}
